import { Reveal } from "./Reveal";
import { ShieldCheck } from "lucide-react";

const VISION_IMG =
  "https://images.pexels.com/photos/6563903/pexels-photo-6563903.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Vision = () => {
  return (
    <section id="ownership" data-testid="vision-section" className="relative py-28 md:py-40 overflow-hidden">
      <img
        src={VISION_IMG}
        alt="Semi truck on an open highway"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/80" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/70 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="flex items-center gap-4 mb-8">
            <ShieldCheck size={32} className="text-orange-500" strokeWidth={1.75} />
            <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-orange-500" data-testid="vision-eyebrow">
              Straight Talk
            </p>
          </div>
          <h2
            className="font-display text-4xl md:text-6xl font-bold uppercase tracking-tighter leading-[0.98] text-white max-w-4xl"
            data-testid="vision-headline"
          >
            Ownership —
            <span className="block text-orange-500">Not Passive Income.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 max-w-2xl space-y-5 text-base md:text-lg text-neutral-300" data-testid="vision-body">
            <p className="text-white font-semibold">
              I Stay Trucking is an operating partner, not an investment fund.
            </p>
            <p>You are building and owning a real regulated transportation business.</p>
            <p>
              Like any business, trucking involves operating expenses, market conditions and
              business risk.
            </p>
            <p>We do not promise guaranteed returns, guaranteed revenue or passive income.</p>
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <p
            className="mt-12 inline-block border-l-4 border-orange-500 pl-6 font-display text-xl md:text-2xl font-semibold uppercase tracking-wide text-white max-w-3xl"
            data-testid="vision-tagline"
          >
            What we provide is the operating infrastructure and experience to help you build and
            manage the company properly.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
